import React from 'react';
import _ from 'lodash';
import UAParser from 'ua-parser-js';
import { object, func, bool } from 'prop-types';
import { I18n, getContext } from '@fiverr-private/fiverr_context';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import { RECOMMENDED_FOR_YOU, CAROUSEL_CONTEXT } from '../../utils/carousels';

import './style.scss';

const SIMILAR_GIGS_SOURCE = 'similar_gigs';

const SimilarGigs = ({
    isTouch,
    isLoggedIn,
    onEmptyGigs,
    shouldFetchCarousel = true
}, {
    general,
    pathfinderWrapper
}) => {
    const { gigId, subCategoryId } = general;
    const { queryParameters, userAgent } = getContext();
    const { ref } = queryParameters;

    const uaParser = new UAParser(userAgent);
    const osName = _.get(uaParser.getOS(), 'name', '').toLowerCase();

    const url = pathfinderWrapper.pathfinder(
        'gig_page_fetch_recommendations_by_type',
        { type: 'by_content' },
        { query: { gig_id: gigId, ref, sub_category_id: subCategoryId, os: osName } }
    );

    return (
        <GigCardCarouselWrapper boxTitle={<I18n k="gig_page_perseus.recommended_gigs.recommended_for_you.title"/>}
            boxClass="gigs-recommended-for-you"
            boxLocation="main"
            type={RECOMMENDED_FOR_YOU}
            url={url}
            onEmptyGigs={onEmptyGigs}
            carouselPosition={1}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            source={SIMILAR_GIGS_SOURCE}
            carouselContext={CAROUSEL_CONTEXT}
            shouldFetchCarousel={shouldFetchCarousel}/>
    );
};

SimilarGigs.propTypes = {
    isTouch: bool,
    isLoggedIn: bool,
    onEmptyGigs: func,
    shouldFetchCarousel: bool
};

SimilarGigs.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { SimilarGigs };
export default SafePureComponent(SimilarGigs);
